<template>
    <v-container fluid>
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>{{ pluralName }}</h1><v-spacer />
                <v-btn
                    v-if="itemType !== 'page'"
                    :to="'/' + itemType + '/create'"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add {{ singularName }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
            >
                <v-card>
                    <v-card-title>
                        <v-text-field
                            v-model="search"
                            prepend-icon="fas fa-search"
                            :label="'Search ' + pluralName"
                            single-line
                            hide-details
                            outlined
                            dense
                            clearable
                        />
                    </v-card-title>
                    <v-card-text>
                        <slot />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { EventBus } from '@/store/eventBus';

export default {
    props: {
        singularName: {
            type: String,
            required: true,
        },

        pluralName: {
            type: String,
            required: true,
        },

        itemType: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            search: '',
            tooltip: false,
        };
    },

    watch: {
        search: function() {
            this.emitIndexSearchTerm();
        }
    },

    mounted() {
        this.loadSearchTerm();
        EventBus.$on('ClearIndexSearch', () => this.clearSearch());
    },

    methods: {
        clearSearch() {
            this.search = null;
            this.emitIndexSearchTerm();
        },

        emitIndexSearchTerm() {
            if (this.search === null) {
                this.search = '';
            }

            EventBus.$emit('IndexSearchTerm', this.search);
            localStorage.setItem(this.singularName.replace(/\s+/g, '') + 'SearchTerm', this.search);
        },

        loadSearchTerm() {
            if (this.search === null) {
                this.search = '';
            }

            this.search = localStorage.getItem(this.singularName.replace(/\s+/g, '') + 'SearchTerm');
            EventBus.$emit('IndexSearchTerm', this.search);
        }
    }
};
</script>
